"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousViolationsInfo = exports.markNewIssues = void 0;
exports.appendIsNewIssueToRawResults = appendIsNewIssueToRawResults;
const createFingerprints_1 = require("./createFingerprints");
/** Marks `isNewIssue` on every node of one current result, in place. */
const markNewIssues = (currentResult, { previousUniqueUrls, previousViolationsMap }) => {
    if (!previousUniqueUrls.has(currentResult.url)) {
        for (const violation of currentResult.violations) {
            for (const node of violation.nodes) {
                node.isNewIssue = true;
            }
        }
        return;
    }
    for (const violation of currentResult.violations) {
        const existingViolation = previousViolationsMap.get(violation.id);
        if (!existingViolation) {
            for (const node of violation.nodes) {
                node.isNewIssue = true;
            }
            continue;
        }
        for (const node of violation.nodes) {
            if (node.target && node.target.length) {
                const currentFingerprints = (0, createFingerprints_1.createFingerprints)({
                    ruleId: violation.id,
                    node,
                    url: currentResult.url
                });
                node.isNewIssue = !currentFingerprints.some(fingerprint => existingViolation.has(fingerprint));
            }
            else {
                // no fingerprints available so consider it a new issue because we cannot match it
                node.isNewIssue = true;
            }
        }
    }
};
exports.markNewIssues = markNewIssues;
/**
 *
 * @param currentResults - the current watcher results
 * @param previousResults - the previous watcher results if they exist
 * @returns the current watcher results with a new property `isNewIssue` appended to each node (if the issue is new)
 */
async function* appendIsNewIssueToRawResults({ currentResults, previousResults }) {
    // Note: If there are no previous results, then we can just return
    // the current results because they are all new.
    //
    // We won't mark each node as `isNewIssue` because client-side we
    // can check if there was a previous result and if there wasn't,
    // we can say all `currentResults` are new. Instead of looping
    // through each node and marking it as `isNewIssue`.
    //
    // This way we can save on performance and not have to loop
    // through each node.
    if (!previousResults) {
        yield* currentResults;
        return;
    }
    const info = (0, exports.getPreviousViolationsInfo)(previousResults);
    for await (const currentResult of currentResults) {
        (0, exports.markNewIssues)(currentResult, info);
        yield currentResult;
    }
}
/**
 * Helper function to get the previous unique URLs and the previous violations map
 * (id -> nodeInfo target selectors and xpath selectors))
 *
 * @param previousResults - The previous watcher results
 * @returns - The previous unique URLs and the previous violations map
 * (id -> nodeInfo target selectors and xpath selectors)
 */
const getPreviousViolationsInfo = (dedupedPreviousResults) => {
    const previousUniqueUrls = new Set();
    const previousViolationsMap = new Map();
    for (const [ruleId, ruleResult] of dedupedPreviousResults.entries()) {
        const fingerprints = new Set();
        for (const unique of ruleResult.uniques) {
            previousUniqueUrls.add(unique.url);
            if (unique.target && unique.target.length) {
                (0, createFingerprints_1.createFingerprints)({
                    ruleId,
                    node: unique
                }).forEach(fingerprint => fingerprints.add(fingerprint));
            }
        }
        previousViolationsMap.set(ruleId, fingerprints);
    }
    return {
        previousUniqueUrls,
        previousViolationsMap
    };
};
exports.getPreviousViolationsInfo = getPreviousViolationsInfo;
//# sourceMappingURL=appendIsNewIssueToRawResults.js.map